<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 9L9 1L17 9V10L1 10V9Z" fill="currentColor" />
  </svg>
</template>
